import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import frtrans from "../locales/fr/translation.json";
import nltrans from "../locales/nl/translation.json";
import entrans from "../locales/en/translation.json";

var language;

if (localStorage.getItem("lang") !== undefined) {
    language = localStorage.getItem("lang")
}
else{
    language = 'NL';
}

i18n.use(initReactI18next).init({
    lng:  language,
    resources: {
        FR: {
            translation: frtrans,
        },
        NL: {
            translation: nltrans,
        },
        EN: {
            translation: entrans,
        }
    }
})

export default i18n;